import { useState, useEffect } from 'react';

import styled from 'styled-components';
import * as moment from 'moment';
import { useRouter } from 'next/router';
import { Rate } from 'antd';
import _ from 'lodash';

import { useQuery } from '@apollo/react-hooks';

import ReviewCard from '../ReviewCard';
import Paging from '../Paging';

import api from '../../lib/restClient';

import * as ReviewQuery from '../../views/reviews/queries';
import * as SubscriptionsQueries from '../../views/subscriptions/queries';

const ShopReviews = () => {
  const router = useRouter();
  const productID = _.get(router, 'query.productId');
  const codeID = _.get(router, 'query.code');

  function getSubscriptionCode(code) {
    switch (code) {
      case 'subscription-1':
        return '4';
      case 'subscription-2':
        return '5';
      case 'subscription-3':
        return '3';
      case 'subscription-4':
        return '15';
      case 'subscription-5':
        return '16';
      default:
        return null;
    }
  }

  const splitLoginProductCode = _(_.get(router, 'query.code'))
    .split('?', 2)
    .value();
  const splitLoginProductID = _(_.get(splitLoginProductCode, '1'))
    .split('=', 2)
    .value();
  const loginProductID = _.get(splitLoginProductID, '1');

  const [pageIndex, setPageIndex] = useState(0);
  const [productReview, setProductReview] = useState({});
  const [averageRate, setAverageRate] = useState(0);

  useEffect(() => {
    async function getAverageRate() {
      try {
        const params = {};
        const subscriptionCode = getSubscriptionCode(codeID);
        if (subscriptionCode) {
          params.meal_id = subscriptionCode;
        } else {
          params.product_id = productID || loginProductID || '';
        }
        const response = await api.get('/review-summary', { params });
        setAverageRate(parseFloat(response?.data?.averageStars.toFixed(1)));
      } catch (error) {
        console.log(error);
      }
    }
    getAverageRate();
  }, []);

  useEffect(() => {
    async function getData() {
      try {
        const params = {
          limit: 10,
          offset: pageIndex * 10,
          ordering: '-stars'
        };
        const subscriptionCode = getSubscriptionCode(codeID);
        if (subscriptionCode) {
          params.meal_id = subscriptionCode;
        } else {
          params.product_id = productID || loginProductID || '';
        }

        const response = await api.get('/reviews', { params });
        setProductReview(response?.data);
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, [pageIndex]);

  const microsaltLunchBox = productID === '1' || productID === '10' || productID === '11' || loginProductID === '1' || loginProductID === '10' || loginProductID === '11';
  const naverLink =
    'https://smartstore.naver.com/microsalts/products/4793162276?NaPm=ct%3Dkdr0io1c%7Cci%3D3dc805ed8ce5c16beead14e48b0d7385d48ad013%7Ctr%3Dslsl%7Csn%3D562465%7Chk%3Db1e88e3ab0037963c9d9cba79e8d84a5f4d392f5#revw';

  const { data: allReviewsData } = useQuery(ReviewQuery.ALL_REVIEWS, {
    fetchPolicy: 'cache-and-network'
  });
  const allReviews = _.get(allReviewsData, 'allReviews');
  // 같은 상품의 리뷰만 보여주는 필터링
  const lunchBoxReviewsFilter = _.filter(allReviews, {
    order: {
      isSubscriptionOrder: false
    },
    orderline: { productVariant: { product: { id: productID || loginProductID } } }
  });
  // FIXME: subscrtipionReview 관련코드 삭제
  const subscrtipionReview = _.filter(allReviews, {
    order: {
      isSubscriptionOrder: true
    }
  });
  const filterReviews = productID === '17' ? subscrtipionReview : lunchBoxReviewsFilter;
  const lunchBoxReviewsLenght = _.size(lunchBoxReviewsFilter);
  const lunchBoxReviewsFilterExist = !_.isEmpty(filterReviews);
  // # 총 평점
  const rateSum = _.sumBy(productID === '17' ? subscrtipionReview : lunchBoxReviewsFilter, function(item) {
    return item.stars;
  });
  //   const averageRate = Math.round(rateSum / (productID === '17' ? subscrtipionReview : lunchBoxReviewsFilter).length) || 0;

  // # 이름 가리는 함수
  const nameHidden = strName => {
    if (_.size(strName) > 2) {
      const originName = _.split(strName, '');
      originName.forEach(function(name, i) {
        if (i === 0 || i === originName.length - 1) return;
        originName[i] = '*';
      });
      const joinName = _.join(originName);
      return joinName && joinName.replace(/,/g, '');
    } else {
      const pattern = /.$/; // 정규식
      return strName && strName.replace(pattern, '*');
    }
  };
  // # 전체후기 버튼 핸들링
  const handleAllReview = () => {
    router.push('/reviews').then(() => {
      window.scrollTo(0, 0);
    });
  };
  return (
    <>
      <Wrapper>
        <AllReviewInfo>
          총 평점 <Rate style={{ margin: '0 1rem', color: '#2f6ecd' }} disabled allowHalf value={averageRate} /> {averageRate || 0} / 5
        </AllReviewInfo>
        <ButtonContainer>
          <ShopWriteReviewButton onClick={handleAllReview}>전체 상품 후기</ShopWriteReviewButton>
          {microsaltLunchBox && (
            <a target="_blank" rel="noopener noreferrer" href={naverLink} style={{ display: 'block', width: '100%' }}>
              <NaverReviewButton>네이버 상품 후기(411)</NaverReviewButton>
            </a>
          )}
        </ButtonContainer>
        {productReview ? (
          productReview?.results?.map(item => {
            const { userName, subscriptionName, productName, created, updated, photoUrl1, photoUrl2, photoUrl3, stars, contents, adminComment, tags } = item;

            return (
              <ReviewContainer>
                <ReviewCard
                  tags={tags}
                  created={created}
                  updated={updated}
                  photoUrl1={photoUrl1}
                  photoUrl2={photoUrl2}
                  photoUrl3={photoUrl3}
                  stars={stars}
                  applicantName={userName}
                  orderName={subscriptionName || productName}
                  contents={contents}
                  adminComment={adminComment}
                  nameHidden={nameHidden}
                />
              </ReviewContainer>
            );
          })
        ) : (
          <div style={{ fontSize: '1.6rem', textAlign: 'center', color: '#bdbdbd', marginTop: '2rem' }}>
            <>작성된 후기가 없습니다.</>
          </div>
        )}
      </Wrapper>
      <Paging totalCount={productReview?.count} pageIndex={pageIndex} setPageIndex={setPageIndex} />
    </>
  );
};
const Wrapper = styled.div`
  padding-top: 2rem;
  margin-bottom: 3rem;
  .ant-rate-star:not(:last-child) {
    margin-right: 1.5px;
  }
  ${props => props.theme.device.md} {
    padding-bottom: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
const AllReviewInfo = styled.div`
  font-size: 1.8rem;
  padding: 0 2rem;
  text-align: center;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  padding: 0 2rem;
  ${props => props.theme.device.md} {
    justify-content: center;
    width: 50%;
    margin: 0 auto;
  }
`;
const ShopWriteReviewButton = styled.a`
  width: 100%;
  background-color: ${props => (props.active ? '#2f6ecd' : 'white')};
  border: ${props => (props.active ? 'none' : '1px solid #2f6ecd')};
  color: ${props => (props.active ? 'white' : '#2f6ecd')};
  display: block;
  padding: 0.5rem;
  text-align: center;
  font-size: 1.6rem;
  font-weight: bold;
  word-break: keep-all;
  margin: 0.5rem 0;
`;
const NaverReviewButton = styled(ShopWriteReviewButton)`
  border: 1px solid #1ec800;
  color: #1ec800;
`;
const ReviewContainer = styled.div`
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.15);
  padding-bottom: 5rem;
  margin-top: 2rem;
  padding: 2rem;
  background-color: white;
`;
export default ShopReviews;
